"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ArchitectureConstructionSignature() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224252" id="klaar-voor-de-volgende-duurzame-klus" className="bg-background text-foreground relative min-h-screen flex items-center overflow-hidden">
      {}
      <style>{`
        @keyframes scroll-line-down {
          0% { transform: translateY(-100%); opacity: 0; }
          50% { opacity: 1; }
          100% { transform: translateY(100%); opacity: 0; }
        }
        .animate-scroll-line {
          animation: scroll-line-down 2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
        }
      `}</style>

      <div className="grid grid-cols-1 lg:grid-cols-12 w-full min-h-screen">
        
        {}
        <div className="col-span-1 lg:col-span-7 relative h-[50vh] lg:h-screen w-full overflow-hidden border-b lg:border-b-0 lg:border-r border-border/30">
          {}
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642666/img/cinematic_brutalist_concrete_building.png)] bg-cover bg-center grayscale-0 contrast-100 scale-105 transition-transform duration-[20s] ease-out hover:scale-110" aria-hidden="true" />
          {}
          <div className="absolute inset-0 bg-secondary/10 lg:bg-transparent mix-blend-multiply" />
          
          {}
          <div className="absolute top-8 left-8 z-20">
            <div className="bg-background/70 backdrop-blur-md border border-border px-4 py-2 rounded-lg shadow-lg">
              <span className="font-mono text-[10px] uppercase tracking-widest text-primary font-bold">● Live Projecten Beschikbaar&nbsp;</span>
            </div>
          </div>
        </div>

        {}
        <div className="col-span-1 lg:col-span-5 flex flex-col justify-center relative px-6 md:px-12 lg:px-16 py-16 lg:py-0 z-10 bg-background/95 lg:bg-transparent backdrop-blur-sm lg:backdrop-blur-none">
          
          <div ref={contentRef} className={`flex flex-col max-w-xl transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="flex items-center gap-4 mb-8">
              <div className="w-8 h-px bg-primary" />
              <span className="font-default text-xs tracking-[0.2em] text-primary uppercase font-bold">CL Installaties Voor ZZP'ers</span>
            </div>

            {}
            <h1 className="font-default text-5xl md:text-7xl lg:text-[84px] font-extrabold leading-[0.9] tracking-tighter uppercase text-secondary">
              Volgende<br />
              <span className="text-primary">Duurzame</span><br />
              Klus?
            </h1>

            {}
            <div className="mt-12 pl-6 border-l-2 border-primary/30 relative">
              <div className="absolute -left-[5px] top-0 w-2 h-2 rounded-none bg-primary" />
              <p className="font-sans text-sm md:text-base text-muted-foreground leading-relaxed max-w-md">
                Wij hebben de projecten, jij de expertise. Direct aan de slag met de installatie van 
                zonnepanelen, thuisbatterijen en warmtepompen. Geen acquisitie gedoe, 
                gewoon bouwen aan een groene toekomst.
              </p>
            </div>

            {}
            <div className="mt-12">
              <Button asChild variant="secondary" size="lg" className="rounded-lg font-default uppercase tracking-wider h-14 px-8 group shadow-xl bg-primary text-primary-foreground hover:bg-primary/90 border-none transition-all duration-300">
                <Link to="#">
                  Bekijk Opdrachten
                  <ArrowRight className="ml-3 size-5 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="hidden lg:flex absolute bottom-12 right-16 flex-col items-center gap-6">
            <span className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground rotate-90 origin-left translate-y-6">
              Ontdek Meer
            </span>
            <div className="w-px h-24 bg-border relative overflow-hidden">
              <div className="w-full h-1/3 bg-primary absolute top-0 animate-scroll-line" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}